export class ValidationStateModel {
    public validationType: string;
    public overrideLevel: number;
    public overrideMessage: string;
    public originalValue: number;
    public requestedValue: number;
    public businessTansactionNumberId: number;
    public validationResourceId: number;
    public validationGroupTypes: number[];
    public escalationRequested = false;
    public customerNumberId: number;
    public vehicleId: number;
}
